const paginationMixin = {
  data: () => ({
    pagination: {
      total: 0,
      currentPage: 1,
      perPage: 0,
      pageCount: 0,
    },
  }),
  computed: {
    loadMoreAvailable() {
      return this.pagination.currentPage < this.pagination.pageCount;
    },
  },
  methods: {
    paginationLoadMore() {
      this.pagination.currentPage += 1;
    },
    fillPaginationData(headers) {
      this.pagination.total = +headers['x-pagination-total-count'] || null;
      this.pagination.currentPage = +headers['x-pagination-current-page'] || null;
      this.pagination.perPage = +headers['x-pagination-per-page'] || null;
      this.pagination.pageCount = +headers['x-pagination-page-count'] || null;
    },
  },
};

export default paginationMixin;
